<template>
  <div class="solution-card" id="solution-card">
    <b-row>
      <b-col md="1" class="p-0 p-lg-3 m-0">
        <p class="text-center sn-p">
          <b-badge pill variant="info" lg>{{ sn }}</b-badge>
        </p>
      </b-col>
      <b-col md="11" class="p-0 p-lg-3 m-0">
        <div
          v-if="question.isPassage == 'true' || JSON.parse(question.isPassage)"
        >
          <h6>
            <b
              >Read the Passage Carefully and Answer the Question that
              Follows</b
            >
          </h6>
          <p v-html="question.passage"></p>
        </div>
        <div
          class="mt-2 mb-2"
          v-if="
            question.isAttachment == 'true' || JSON.parse(question.isAttachment)
          "
        >
          <img :src="question.image_link" class="queimg" alt="Question Image" />
        </div>
        <div class="">
          <p class="" v-html="question.question"></p>
        </div>

        <form v-if="question.structure == 'MCQ'">
          <b-form-radio-group
            id="queoption"
            v-model="answer"
            disabled
            stacked
            class="form-rad"
          >
            <b-form-radio value="A">
              <div class="dispf m-0">
                <p class="fl1 mr-2">a)</p>
                <p class="fl2" v-html="question.a"></p>
                <p class="fl3" v-if="answer == 'A'">
                  <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="success"></b-icon>
                    <b-icon stacked icon="check" variant="success"></b-icon>
                  </b-iconstack>
                  <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="danger"></b-icon>
                    <b-icon stacked icon="x" variant="danger"></b-icon>
                  </b-iconstack>
                </p>
              </div>
            </b-form-radio>
            <b-form-radio value="B">
              <div class="dispf m-0">
                <p class="fl1 mr-2">b)</p>
                <p class="fl2" v-html="question.b"></p>
                <p class="fl3" v-if="answer == 'B'">
                  <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="success"></b-icon>
                    <b-icon stacked icon="check" variant="success"></b-icon>
                  </b-iconstack>
                  <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="danger"></b-icon>
                    <b-icon stacked icon="x" variant="danger"></b-icon>
                  </b-iconstack>
                </p>
              </div>
            </b-form-radio>
            <b-form-radio value="C">
              <div class="dispf m-0">
                <p class="fl1 mr-2">c)</p>
                <p class="fl2" v-html="question.c"></p>
                <p class="fl3" v-if="answer == 'C'">
                  <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="success"></b-icon>
                    <b-icon stacked icon="check" variant="success"></b-icon>
                  </b-iconstack>
                  <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="danger"></b-icon>
                    <b-icon stacked icon="x" variant="danger"></b-icon>
                  </b-iconstack>
                </p>
              </div>
            </b-form-radio>
            <b-form-radio value="D">
              <div class="dispf m-0">
                <p class="fl1 mr-2">d)</p>
                <p class="fl2" v-html="question.d"></p>
                <p class="fl3" v-if="answer == 'D'">
                  <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="success"></b-icon>
                    <b-icon stacked icon="check" variant="success"></b-icon>
                  </b-iconstack>
                  <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="danger"></b-icon>
                    <b-icon stacked icon="x" variant="danger"></b-icon>
                  </b-iconstack>
                </p>
              </div>
            </b-form-radio>
            <b-form-radio v-if="question.e != ''" value="E">
              <div class="dispf m-0">
                <p class="fl1 mr-2">e)</p>
                <p class="fl2" v-html="question.e"></p>
                <p class="fl3" v-if="answer == 'E'">
                  <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="success"></b-icon>
                    <b-icon stacked icon="check" variant="success"></b-icon>
                  </b-iconstack>
                  <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
                    <b-icon stacked icon="square" variant="danger"></b-icon>
                    <b-icon stacked icon="x" variant="danger"></b-icon>
                  </b-iconstack>
                </p>
              </div>
            </b-form-radio>
          </b-form-radio-group>
        </form>

        <p v-if="question.structure == 'OEQ'" class="">
          Your Answer :
          <span :class="correcta == true ? 'color-green' : 'color-red'">{{
            this.qattempted.filter(x => x.track_id == this.question.track_id)[0]
              .answer
          }}</span>
          <b-iconstack v-if="correcta" class="ml-2" font-scale="1.3">
            <b-icon stacked icon="square" variant="success"></b-icon>
            <b-icon stacked icon="check" variant="success"></b-icon>
          </b-iconstack>
          <b-iconstack v-if="!correcta" class="ml-2" font-scale="1.3">
            <b-icon stacked icon="square" variant="danger"></b-icon>
            <b-icon stacked icon="x" variant="danger"></b-icon>
          </b-iconstack>
        </p>
        <p
          v-if="question.structure == 'OEQ'"
          class="d-inline-block solution-line-items"
        >
          Correct Answer :
          <span class="color-green">{{
            this.qattempted.filter(x => x.track_id == this.question.track_id)[0]
              .oeq_answer
          }}</span>
        </p>

        <p
          v-if="!correcta && question.structure == 'MCQ'"
          class="d-inline-block solution-line-items"
        >
          Correct Answer :
          <span v-if="question.structure == 'MCQ'" class="color-green">{{
            this.qattempted.filter(x => x.track_id == this.question.track_id)[0]
              .correct
          }}</span>
        </p>
        <p class="d-inline-block solution-line-items ml-lg-4 ml-1">
          Topic Reference : <i>{{ question.topic_reference }}</i>
        </p>

        <h3 class="color-green">Solution</h3>
        <div v-if="question.isSolution == 'Yes' || question.isSolution">
          <div
            v-if="question.solutiontype == 'Text'"
            v-html="question.solution"
          ></div>
          <div v-if="question.solutiontype == 'Image'">
            <img
              :src="question.solution"
              class="solimg"
              :title="question.question"
              alt="Image Solution to Question"
            />
          </div>
        </div>
        <b-modal
          :id="'coming-soon' + '_' + sn"
          centered
          title="Coming Soon!"
          hide-footer
          hide-header
        >
          <template #default>
            <div class="coming-modal">
              <img class="ddimg" src="@/assets/comingsoon.jpg" />
            </div>
          </template>
          <!-- <template #modal-footer>
                  <a href="https://quicktestng.com/upgrade?plan=Premium" class="w-100 text-center" target="_blank">
                      <b-button class="bgupgrade mx-auto">Upgrade to Premium Now</b-button>
                  </a>
              </template> -->
        </b-modal>

        <div hidden class="mt-4">
          <b-button
            variant="outline-success"
            class="m-lg-3 mt-2 p-2 action-button"
            @click="$bvModal.show('coming-soon_' + sn)"
            ><b-icon-play-circle font-scale="1"></b-icon-play-circle> Watch
            explanation on {{ question.topic_reference }}</b-button
          >
          <b-button
            class="m-lg-3 mt-2 p-2 action-button download-own"
            variant="success"
            @click="printElement"
            ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
            Download Solutions (pdf)
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    question: Object,
    qattempted: Array,
    sn: Number
  },
  data() {
    return {
      correcta: false,
      check: "ddd",
      correctoption: ""
    };
  },
  created() {
    this.checkGot();

    let mathjaxlink =
      this.environ == "development"
        ? "http://localhost/quicktest/plugins/Mathjax/MathJax.js?config=MML_HTMLorMML"
        : "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML";

    window.MathJax = {
      MathML: { extensions: ["mml3.js", "content-mathml.js"] }
    };
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", mathjaxlink);
    document.head.appendChild(externalScript);
  },
  methods: {
    checkGot() {
      let gotid = this.qattempted
        .filter(x => x.track_id == this.question.track_id)
        .filter(x => x.answer.toLowerCase() == x.correct.toLowerCase());

      let queobj = this.qattempted.filter(
        x => x.track_id == this.question.track_id
      );
      // console.log(queobj)

      if (this.question.structure == "OEQ") {
        let cleananswer = queobj[0].answer;
        let cleancorrect = queobj[0].oeq_answer;

        let patt1 = /\s+/; // Cleans the texts of extra spaces in any occurrence
        let patt2 = /\.+$/; // Cleans the Text of full stops at the end of the statement. Any number Full stops after the last letter is overlooked

        let cleanedanswer1 = cleananswer.replace(patt1, " ");
        let answercleaned = cleanedanswer1.replace(patt2, "");

        let cleanedcorrect1 = cleancorrect.replace(patt1, " ");
        let correctcleaned = cleanedcorrect1.replace(patt2, "");

        // var_dump(strtoupper(answercleaned));
        // var_dump(strtoupper(correctcleaned));

        let markanswer = answercleaned;
        let markcorrect = correctcleaned;

        console.log(markanswer);
        console.log(markcorrect);

        if (
          markanswer.toLowerCase().trim() == markcorrect.toLowerCase().trim()
        ) {
          this.correcta = true;
        }
      } else if (this.question.structure == "MCQ") {
        if (gotid.length > 0) {
          this.correcta = true;
          //this.correctoption = x.correct.toLowerCase()
        }
      }
    },
    printElement() {
      var $printSection = document.getElementById("solution-card");
      var currentBody = document.body.innerHTML;

      document.body.innerHTML = $printSection.innerHTML;

      window.print();

      document.body.innerHTML = currentBody;

      this.$forceUpdate();
    }
  },

  computed: {
    answer() {
      let gotid = this.qattempted
        .filter(x => x.track_id == this.question.track_id)
        .map(x => x.answer);

      return gotid[0];
    },
    ...mapState({
      environ: state => state.loginmaster.environ
    })
  }
};
</script>

<style scoped>
.dispf {
  display: flex;
  margin-top: -10px;
  cursor: pointer;

  color: black;
}

.sqdispf {
  display: flex;
}

.sqicon {
  width: 10%;
  text-align: left;
}

.sqque {
  width: 90%;
  font-size: 1.2rem;
}

.solution-line-items {
  font-size: 1.1rem;
}
.solution-card {
  background-color: rgba(251, 252, 251, 0.522);
}
.color-green {
  color: #00984a;
}
.color-red {
  color: red;
}
.action-button {
  width: 300px;
}

.download-own:hover {
  background-color: white;
  border: 1px solid #00984a;
  color: #00984a;
}
.ddimg {
  width: 100%;
  height: 300px;
}
.sn-p {
  font-size: 1.5rem;
}

@media screen and (min-width: 768px) {
  .solimg {
    width: 50%;
  }
  .queimg {
    width: 50%;
  }
}

@media screen and (max-width: 999px) {
  .queimg {
    width: 100%;
  }
  .solimg {
    width: 100%;
  }
  .action-button {
    width: 230px;
    font-size: 0.8rem;
  }
}
</style>
